export const hosturl ="https://labourbackend.aptapace.com"

// export const hosturl ="http://192.168.1.17:4000"